export default __webpack_public_path__ + "static/media/recruit_table_icon_4.26cee815.svg";